var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",function(){return [_vm._v("Main EHR content selected by the router")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }